import React from "react";
import { ProductQRCode } from "../../utils/qr";

const InvoiceTemplate2 = ({ orderData, InvoiceData }) => {
    if (!orderData) return null;
    console.log(InvoiceData, "InvoiceDataInvoiceDataInvoiceData");
    // Style constants
    const thStyle = {
        border: "1px solid #000",
        fontWeight: "bold",
    };

    const tdStyle = {
        borderLeft: "1px solid #000",
        borderRight: "1px solid #000",
        borderTop: "0",
        borderBottom: "0",
        padding: "5px",
        verticalAlign: "top",
    };

    // Helper functions
    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date
            .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            })
            .replace(/\//g, "-");
    };

    const formatCurrency = (amount) => {
        return parseFloat(amount || 0)?.toFixed(2);
    };

    const getAmountInWords = (num) => {
        const ones = [
            "",
            "One",
            "Two",
            "Three",
            "Four",
            "Five",
            "Six",
            "Seven",
            "Eight",
            "Nine",
        ];
        const tens = [
            "",
            "",
            "Twenty",
            "Thirty",
            "Forty",
            "Fifty",
            "Sixty",
            "Seventy",
            "Eighty",
            "Ninety",
        ];
        const teens = [
            "Ten",
            "Eleven",
            "Twelve",
            "Thirteen",
            "Fourteen",
            "Fifteen",
            "Sixteen",
            "Seventeen",
            "Eighteen",
            "Nineteen",
        ];

        function convertLessThanOneThousand(num) {
            if (num === 0) return "";
            if (num < 10) return ones[num];
            if (num < 20) return teens[num - 10];
            if (num < 100)
                return (
                    tens[Math.floor(num / 10)] +
                    (num % 10 !== 0 ? " " + ones[num % 10] : "")
                );
            return (
                ones[Math.floor(num / 100)] +
                " Hundred" +
                (num % 100 !== 0 ? " and " + convertLessThanOneThousand(num % 100) : "")
            );
        }

        if (num === 0) return currency === "SGD" ? "Zero Singapore Dollars Only" : "Zero Rupees Only";
        let result = "";
        if (Math.floor(num / 10000000) > 0) {
            result +=
                convertLessThanOneThousand(Math.floor(num / 10000000)) + " Crore ";
            num %= 10000000;
        }
        if (Math.floor(num / 100000) > 0) {
            result += convertLessThanOneThousand(Math.floor(num / 100000)) + " Lakh ";
            num %= 100000;
        }
        if (Math.floor(num / 1000) > 0) {
            result +=
                convertLessThanOneThousand(Math.floor(num / 1000)) + " Thousand ";
            num %= 1000;
        }
        if (num > 0) {
            result += convertLessThanOneThousand(num);
        }
        return result + (currency === "SGD" ? " Singapore Dollars Only" : " Rupees Only");
    };

    // Extract data from order
    const {
        orderCode = "",
        createdAt = "",
        shippingAddress = {},
        user = {},
        items = [],
        products = [],
        paymentMode = "",
        invoiceId = "",
        discount: orderDiscount = 0,
        totalDiscount,
        gstNumber,
        // New fields directly from data
        subTotal: apiSubTotal = 0,
        total: apiTotal = 0,
        customerTotalTax = 0,
        deliveryCharge = 0,
        discount = 0,
        currency = "INR",
    } = orderData.data || orderData;

    const currencySymbol = currency === "SGD" ? "S$" : "₹";

    // Map new fields to existing variables
    const subTotal = apiSubTotal;
    const tax = customerTotalTax;
    const shippingCharge = deliveryCharge;
    const total = Number(apiTotal);
    const totalGross = subTotal + tax;
    const itemDiscounts = items.reduce(
        (acc, item) => acc + (item.discount || 0), // Assuming item.discount exists or is 0
        0
    );
    const lessFrightChargee = discount || totalDiscount || 0;
    const overAllDiscount = itemDiscounts + lessFrightChargee;
    const subtotalAfterDiscount = subTotal;

    const totalSubTotal = subTotal; // Renaming for consistency with usage below
    // Calculate tax breakdown for the new GST table
    const taxGroups = items.reduce((acc, item, index) => {
        const product = products[index] || {};

        // Tax Rate Logic: Prefer item.taxRate, fallback to product.customerTax
        const taxRate = item.taxRate || product.customerTax || 0;

        if (!acc[taxRate]) {
            acc[taxRate] = { totalAmount: 0, totalTax: 0, count: 0 };
        }

        const itemTotal = (item.unitPrice || 0) * (item.quantity || 1);

        const taxableAmount = itemTotal - (item.discount || 0);


        const taxAmount = (taxableAmount * taxRate) / 100;

        acc[taxRate].totalAmount += (taxableAmount - taxAmount)
        acc[taxRate].totalTax += taxAmount;
        acc[taxRate].count += 1;

        return acc;
    }, {});

    // Map products with their details
    const productDetails = items.map((item, index) => {
        const product = products[index] || {};
        const taxRate = item.taxRate || product.customerTax || 0;

        const quantity = item.quantity || 1;
        const unitPrice = item.unitPrice || 0;
        const itemTotal = unitPrice * quantity;
        const itemDiscount = item.discount || 0;

        const taxableAmount = itemTotal - itemDiscount;
        const taxAmount = (taxableAmount * taxRate) / 100;

        let variantDetails = "";
        if (item.attributes && product.attributeData) {
            variantDetails = Object.entries(item.attributes)
                .map(([key, valueId]) => {
                    const attrGroup = product.attributeData.find(
                        (ad) => ad.name?.toLowerCase() === key.toLowerCase()
                    );
                    if (attrGroup?.value) {
                        const valObj = attrGroup.value.find((v) => v._id === valueId);
                        if (valObj) {
                            const formattedKey = key.charAt(0).toUpperCase() + key.slice(1);
                            return `${formattedKey}: ${valObj.value}`;
                        }
                    }
                    return null;
                })
                .filter(Boolean)
                .join(", ");
        }

        return {
            ...item,
            ...product,
            index: index + 1,
            itemTotal: itemTotal, // Total value of line item (before tax)
            itemDiscount: itemDiscount,
            taxAmount: taxAmount,
            taxRate: taxRate, // Ensure taxRate is available for table
            variantDetails: variantDetails
        };
    });

    // Calculate total weight
    const totalWeight = productDetails.reduce((total, product) => {
        return total + (product.quantity || 0);
    }, 0);

    return (
        <div
            style={{
                width: "148mm",
                minHeight: "210mm",
                margin: "0 auto",
                padding: "3mm",
                fontFamily: "Arial",
                backgroundColor: "white",
                fontSize: "8px",
                lineHeight: "1.4",
                boxSizing: "border-box",
                border: "2px solid #000",
                position: "relative",
                display: "flex",
                flexDirection: "column",
            }}
        >
            {/* Header */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingBottom: "5px",
                    marginBottom: "8px",
                    borderBottom: "1px solid #000",
                    flexShrink: 0,
                }}
            >
                {/* Left: Company Logo */}
                <div style={{ width: "25%", textAlign: "left" }}>
                    <img
                        src="/img/logo/Colors-logo.jpg"
                        alt="Company Logo"
                        style={{
                            height: "70px",
                            width: "160px",
                            objectFit: "contain",
                        }}
                    />
                </div>

                {/* Center: Company Details */}
                <div style={{ textAlign: "center", width: "50%" }}>
                    <div
                        style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            marginBottom: "3px",
                        }}
                    >
                        COLOURS BOUTIQUE
                    </div>
                    <div style={{ fontSize: "9px", lineHeight: "1.3" }}>
                        <div>No:48, Seerangoon Road, #01-22/23,</div>
                        <div>Little India Arcade, Singapore-217959.</div>
                        <div>
                            <strong>Ph:</strong> 94572783, 62994646
                        </div>
                    </div>
                </div>
            </div>

            {/* Customer Details */}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "1fr auto",
                    alignItems: "start",
                    gap: "5px",
                    border: "1px solid #000",
                    padding: "10px",
                    marginBottom: "10px",
                    fontSize: "10px",
                }}
            >
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
                        gap: "8px 12px",
                        fontSize: "10px",
                    }}
                >
                    <div
                        style={{ display: "flex", flexDirection: "column", gap: "4px", textAlign: 'left' }}
                    >
                        <div>
                            <strong>Name:</strong>{" "}
                            <span style={{ fontWeight: "bold", fontSize: "11px" }}>
                                {shippingAddress.contactName || "N/A"}
                            </span>
                        </div>
                        <div>
                            <strong>Address:</strong>{" "}
                            <span style={{ fontWeight: "bold", fontSize: "11px" }}>
                                {shippingAddress.street || "N/A"}
                            </span>
                        </div>
                        <div>
                            <strong>Ph:</strong>{" "}
                            <span style={{ fontWeight: "bold", fontSize: "11px" }}>
                                {shippingAddress.contactNumber || "N/A"}
                            </span>
                        </div>
                        <div>
                            <strong>GSTIN:</strong>{" "}
                            <span style={{ fontWeight: "bold", fontSize: "11px" }}>
                                {shippingAddress.gstin || gstNumber || "N/A"}
                            </span>
                        </div>
                    </div>

                    <div
                        style={{ display: "flex", flexDirection: "column", gap: "4px", textAlign: 'left' }}
                    >
                        <div>
                            <strong>Inv. No:</strong>{" "}
                            <span style={{ fontWeight: "bold", fontSize: "11px" }}>
                                {invoiceId || orderCode}
                            </span>
                        </div>
                        <div>
                            <strong>Bill Date:</strong>{" "}
                            <span style={{ fontWeight: "bold", fontSize: "11px" }}>
                                {formatDate(createdAt)}
                            </span>
                        </div>
                        <div>
                            <strong>Bill Type:</strong>{" "}
                            <span style={{ fontWeight: "bold", fontSize: "11px" }}>
                                {paymentMode} {currency ? `(${currency})` : ""}
                            </span>
                        </div>
                        <div>
                            <strong>Area:</strong>{" "}
                            <span style={{ fontWeight: "bold", fontSize: "11px" }}>
                                {shippingAddress.city || "N/A"}
                            </span>
                        </div>
                        <div>
                            <strong>Order BY:</strong>{" "}
                            <span style={{ fontWeight: "bold", fontSize: "11px" }}>
                                {user?.name || "N/A"}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Products Table */}
            <div style={{ marginBottom: "10px", flexGrow: 1, paddingBottom: "2px" }}>
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "12px",
                        border: "1px solid #000",
                        tableLayout: "fixed",
                    }}
                >
                    <thead>
                        <tr
                            style={{
                                backgroundColor: "#f0f0f0",
                                borderBottom: "1px solid #000",
                            }}
                        >
                            <th style={{ ...thStyle, padding: "8px", width: "8%" }}>S.No</th>
                            <th style={{ ...thStyle, padding: "8px", width: "43%", textAlign: "left" }}>
                                Product
                            </th>
                            <th style={{ ...thStyle, padding: "8px", width: "10%" }}>QTY</th>
                            <th style={{ ...thStyle, padding: "8px", width: "7%" }}>GST</th>
                            <th style={{ ...thStyle, padding: "8px", width: "12%" }}>Rate</th>
                            <th style={{ ...thStyle, padding: "8px", width: "8%" }}>Disc</th>
                            <th style={{ ...thStyle, padding: "8px", width: "15%" }}>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {productDetails.map((product, index) => {
                            const isVeryLastRow = index === productDetails.length - 1 && productDetails.length >= 5;
                            const rowStyle = { height: "40px", border: "none" };

                            return (
                                <tr key={index} style={rowStyle}>
                                    {["index", "productName", "quantity", "taxRate", "unitPrice", "discount", "itemTotal"].map((field, i) => {
                                        const baseStyle = {
                                            ...tdStyle,
                                            borderBottom: isVeryLastRow ? "1px solid #000" : "1px solid transparent",
                                        };

                                        if (field === "index") return <td key={i} style={{ ...baseStyle, textAlign: "center" }}>{product.index}</td>;
                                        if (field === "productName") return (
                                            <td key={i} style={{ ...baseStyle, textAlign: "left", fontWeight: "bold" }}>
                                                <div style={{ fontSize: "13px" }}>{product.productName}</div>
                                                {product.variantDetails && (
                                                    <div style={{ fontSize: "11px", fontWeight: "normal", color: "#666" }}>
                                                        ({product.variantDetails})
                                                     </div>
                                                )}
                                            </td>
                                        );
                                        if (field === "quantity") return <td key={i} style={{ ...baseStyle, textAlign: "center" }}>{product.quantity}</td>;
                                        if (field === "taxRate") return <td key={i} style={{ ...baseStyle, textAlign: "center" }}>{product.taxRate}%</td>;
                                        if (field === "unitPrice") return <td key={i} style={{ ...baseStyle, textAlign: "center" }}>{formatCurrency(product.unitPrice)}</td>;
                                        if (field === "discount") return <td key={i} style={{ ...baseStyle, textAlign: "center" }}>{product.discount || "0.00"}</td>;
                                        if (field === "itemTotal") return <td key={i} style={{ ...baseStyle, textAlign: "right", fontWeight: "bold", paddingRight: "5px" }}>{formatCurrency(product.itemTotal)}</td>;
                                        return null;
                                    })}
                                </tr>
                            );
                        })}
                        {/* Optional: Add a few empty rows if the list is very short to maintain a minimum table height */}
                        {productDetails.length < 5 && [...Array(8 - productDetails.length)].map((_, index, arr) => (
                            <tr key={`empty-${index}`} style={{ height: "40px", border: "none" }}>
                                {Array(7).fill(null).map((_, i) => (
                                    <td key={i} style={{
                                        ...tdStyle,
                                        borderBottom: index === arr.length - 1 ? "1px solid #000" : "1px solid transparent"
                                    }}></td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Footer */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "9px",
                    border: "1px solid #000",
                    padding: "5px",
                    gap: "5px",
                    flexShrink: 0,
                }}
            >
                {/* Left Column */}
                <div style={{ width: "50%" }}>
                    <div style={{ marginBottom: "8px", textAlign: "left" }}>
                        <strong>Total Items: {productDetails.length}</strong>
                    </div>

                    <div style={{ marginBottom: "10px", textAlign: "left" }}>
                        <div>
                            <strong>Amount in Words:</strong>
                        </div>
                        <div>{getAmountInWords(total)}</div>
                    </div>

                    {/* GST Table */}
                    <div style={{ marginBottom: "8px" }}>
                        <table
                            style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                fontSize: "8px",
                                border: "1px solid #000",
                            }}
                        >
                            <thead>
                                <tr style={{ backgroundColor: "#f5f5f5" }}>
                                    <th style={{ ...thStyle, padding: "4px" }}>GST%</th>
                                    <th style={{ ...thStyle, padding: "4px" }}>Sale Amt</th>
                                    <th style={{ ...thStyle, padding: "4px" }}>GST</th>
                                    <th style={{ ...thStyle, padding: "4px" }}>CGST</th>
                                    <th style={{ ...thStyle, padding: "4px" }}>SGST</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(taxGroups)
                                    .filter(([rate]) => parseFloat(rate) > 0)
                                    .map(([rate, data]) => {
                                        const gstRate = parseFloat(rate);
                                        const totalGst = data.totalTax;
                                        return (
                                            <tr key={`tax-${gstRate}`}>
                                                <td style={{ ...tdStyle, textAlign: "center", padding: "2px" }}>{gstRate}%</td>
                                                <td style={{ ...tdStyle, textAlign: "right", padding: "2px" }}>{currencySymbol}{formatCurrency(data.totalAmount)}</td>
                                                <td style={{ ...tdStyle, textAlign: "right", padding: "2px" }}>{currencySymbol}{formatCurrency(totalGst)}</td>
                                                <td style={{ ...tdStyle, textAlign: "right", padding: "2px" }}>{currencySymbol}{formatCurrency(totalGst / 2)}</td>
                                                <td style={{ ...tdStyle, textAlign: "right", padding: "2px" }}>{currencySymbol}{formatCurrency(totalGst / 2)}</td>
                                            </tr>
                                        );
                                    })}
                                {Object.keys(taxGroups).filter(rate => parseFloat(rate) > 0).length === 0 && (
                                    <tr>
                                        <td style={{ ...tdStyle, textAlign: "center", padding: "2px" }}>0%</td>
                                        <td style={{ ...tdStyle, textAlign: "right", padding: "2px" }}>{currencySymbol}{formatCurrency(subTotal)}</td>
                                        <td style={{ ...tdStyle, textAlign: "right", padding: "2px" }}>{currencySymbol}0.00</td>
                                        <td style={{ ...tdStyle, textAlign: "right", padding: "2px" }}>{currencySymbol}0.00</td>
                                        <td style={{ ...tdStyle, textAlign: "right", padding: "2px" }}>{currencySymbol}0.00</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* <div style={{ marginBottom: "5px", textAlign: "left" }}>
                        <div><strong>Bank: HDFC BANK</strong></div>
                        <div><strong>A/C No:</strong> 4242423424</div>
                        <div><strong>IFSC:</strong> 123456789</div>
                    </div> */}

                    <div style={{ fontSize: "7px", textAlign: "left" }}>
                        <div>Any Legal dispute solved by 1996 Arbitration act</div>
                        <div>in coimbatore jurisdiction only.</div>
                        <div><strong>Declaration:</strong> We declare that this invoice shows the actual price of</div>
                        <div>the goods and all particulars are true and correct.</div>
                    </div>
                </div>

                {/* Right Column */}
                <div style={{ width: "40%" }}>
                    <div style={{ textAlign: "right", marginBottom: "10px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "2px" }}>
                            <span>Total Amount (Gross) :</span>
                            <span>{currencySymbol}{formatCurrency(totalGross)}</span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "2px" }}>
                            <span>Item Discounts :</span>
                            <span>-{currencySymbol}{formatCurrency(itemDiscounts)}</span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "2px" }}>
                            <span>Sub Total :</span>
                            <span>{currencySymbol}{formatCurrency(totalSubTotal)}</span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "2px" }}>
                            <span>Fright :</span>
                            <span>{currencySymbol}{formatCurrency(shippingCharge)}</span>
                        </div>
                        {lessFrightChargee > 0 && (
                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "2px" }}>
                                <span>Less Fright :</span>
                                <span>-{currencySymbol}{formatCurrency(lessFrightChargee)}</span>
                            </div>
                        )}
                        <div style={{ display: "flex", justifyContent: "space-between", borderTop: "1px solid #000", paddingTop: "3px", fontSize: "16px", fontWeight: "bold", marginTop: "5px" }}>
                            <span>Net Amount :</span>
                            <span>{currencySymbol}{formatCurrency(total)}</span>
                        </div>
                        <div style={{ textAlign: "right", marginTop: "3px" }}>
                            <strong>for COLOURS BOUTIQUE</strong>
                        </div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: "15px", paddingTop: "15px", fontSize: "10px" }}>
                        <div style={{ textAlign: "left" }}>RECEIVER SIGN</div>
                        <div style={{ textAlign: "right" }}><strong>Authorized Signatory</strong></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvoiceTemplate2;

